export default __webpack_public_path__ + "static/avatar-kayi-common-5-detail-a8fb7dcea90cad4b81a1b5c3c1eccefc.png";